import React, { useEffect } from "react";
import { Col, Row } from "@deere/ux.uxframe-react";

const STErrorPage = (props) => {
  useEffect(() => {
    props.setShowHeaderFooter(false);
  }, []);
  return (
    <main id="content" className="container-fluid bg-gray pt-4 pb-5" style={{ height: "100vh" }}>
      <Row className="align-items-center h-100">
        <Col md="24" className="col w-100 text-center">
          <h1 className="display-6">Log in attempt has failed due to invalid url.</h1>
          <svg focusable="false" aria-hidden="true" fill="#666666" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style={{ width: "200px", height: "200px" }}>
            <path d="M0 0h24v24H0z" fill="none"></path>
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path>
          </svg>
          <p className="text-muted w-100">Timestamp: {Date().toLocaleString()}</p>
        </Col>
      </Row>
    </main>
  );
};

export default STErrorPage;
